"use strict";
import { sanitizeEmailPreviewHtml } from "./email_preview_sanitizer.js";
const modifyEmailHtmlForPreview = (bodyValue) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = bodyValue;
  let figures = tempDiv.getElementsByTagName("figure");
  for (let figure of figures) {
    let table = figure.querySelector("table");
    if (!table) {
      continue;
    }
    figure.classList.remove("table");
    figure.classList.add("richtext_table_figure");
    if (figure.style.width) {
      table.style.width = "100%";
    }
  }
  for (let figure of figures) {
    let img = figure.querySelector("img");
    if (!img) {
      continue;
    }
    if (!figure.classList.contains("image-style-align-right") && !figure.classList.contains("image-style-align-left")) {
      figure.classList.add("image-style-align-center");
    }
    img.style.width = "100%";
  }
  tempDiv.querySelectorAll("img").forEach((img) => {
    img.alt = img.hasAttribute("alt") ? img.alt.trim() : "Image attachment";
  });
  const isInMjmlSection = (el) => !!el.closest(".amt-system-body, .amt-appended-template");
  let tables = tempDiv.getElementsByTagName("table");
  for (let table of tables) {
    if (isInMjmlSection(table)) {
      continue;
    }
    table.style.borderStyle = table.style.borderStyle || "solid";
    table.style.borderColor = table.style.borderColor || "#bfbfbf";
    table.style.borderWidth = table.style.borderWidth || "1px";
  }
  let cells = tempDiv.getElementsByTagName("td");
  for (let cell of cells) {
    if (isInMjmlSection(cell)) {
      continue;
    }
    cell.style.borderStyle = cell.style.borderStyle || "solid";
    cell.style.borderColor = cell.style.borderColor || "#bfbfbf";
    cell.style.borderWidth = cell.style.borderWidth || "1px";
    cell.style.textAlign = cell.style.textAlign || "left";
    cell.style.verticalAlign = cell.style.verticalAlign || "middle";
    cell.style.padding = cell.style.padding || "10px";
  }
  let ps = tempDiv.getElementsByTagName("p");
  for (let p of ps) {
    p.style.padding = p.style.padding || "6px 8px 6px 8px";
  }
  tempDiv.querySelectorAll(".itemized-gifts-section").forEach((el) => {
    el.style.padding = el.style.padding || "0 8px";
  });
  return tempDiv.innerHTML;
};
const PREVIEW_IFRAME_SRCDOC_PREFIX = `<!DOCTYPE html><html><head><meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="default-src 'none'; style-src 'unsafe-inline'; img-src data: https:;"><base target="_blank"><style>body{font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:1.5;color:#333;margin:0;padding:12px;word-wrap:break-word;}p{display:block;padding:6px 8px;margin:0;}img{max-width:100%;height:auto;}table{border-collapse:collapse;}td,th{padding:4px 8px;}</style></head><body>`;
const PREVIEW_IFRAME_SRCDOC_SUFFIX = "</body></html>";
const writeToPreviewIframe = (iframe, html) => {
  if (!iframe) return;
  const sanitized = sanitizeEmailPreviewHtml(html);
  const nextSrcdoc = PREVIEW_IFRAME_SRCDOC_PREFIX + sanitized + PREVIEW_IFRAME_SRCDOC_SUFFIX;
  const assignSrcdoc = () => {
    iframe.removeAttribute("srcdoc");
    iframe.srcdoc = "";
    iframe.srcdoc = nextSrcdoc;
  };
  const needsDeferredPaint = iframe.style.display === "none" || iframe.hasAttribute("hidden") || !iframe.getAttribute("srcdoc") && iframe.srcdoc === "";
  if (needsDeferredPaint) {
    if (iframe.style.display === "none") {
      iframe.style.display = "block";
    }
    iframe.removeAttribute("hidden");
    requestAnimationFrame(() => {
      void iframe.offsetHeight;
      assignSrcdoc();
    });
    return;
  }
  assignSrcdoc();
};
export { modifyEmailHtmlForPreview, writeToPreviewIframe, sanitizeEmailPreviewHtml };
